import apiClient from './apiClient';

/**
 * Hotel custom key/values — dynamic email-template placeholders.
 *
 * scope 'hotel': one value for the property ({{key}} in templates).
 * scope 'room':  a value per room; {{key}} resolves via the guest's
 *                assigned room at send time, {{key_<room_number>}}
 *                addresses one room's value explicitly.
 *
 * Every mutation returns the full refreshed payload
 * ({fields, rooms, reservedKeys}).
 */
const customFieldService = {
  get: () => apiClient.get('/v1/settings/custom-fields'),
  create: (data) => apiClient.post('/v1/settings/custom-fields', data),
  update: (id, data) => apiClient.put(`/v1/settings/custom-fields/${id}`, data),
  // Image fields upload as multipart: file under 'image' (hotel scope) or
  // 'image_room_<roomId>' (room scope); 'clearImage' / 'clear_image_room_<id>'
  // remove a stored upload.
  createForm: (formData) => apiClient.postForm('/v1/settings/custom-fields', formData),
  updateForm: (id, formData) => apiClient.putForm(`/v1/settings/custom-fields/${id}`, formData),
  remove: (id) => apiClient.del(`/v1/settings/custom-fields/${id}`),
};

export default customFieldService;
